import { useState, useMemo } from 'react';
import { createPortal } from 'react-dom';
import ModalCloseButton from './ModalCloseButton';

const RemovePlayerModal = ({
  player,
  onConfirm,
  onClose,
}) => {
  const [typedCode, setTypedCode] = useState('');

  // Generate random 4-digit security code
  const securityCode = useMemo(() => {
    return Math.floor(1000 + Math.random() * 9000).toString();
  }, []);

  const isCodeCorrect = typedCode.trim() === securityCode;

  return createPortal(
    <div className="modal-overlay">
      <div className="modal">
        <ModalCloseButton onClick={onClose} />

        <h3 className="modal-title">
          Are you sure?
        </h3>

        <div className="modal-body">
          <p className="modal-text">
            This will remove <strong>{player?.name || 'this player'}</strong> from the players list and all their stats.
          </p>
          <p className="modal-text modal-text-strong">
            Once confirmed this can't be undone.
          </p>

          <div className="mt-4 pt-4 border-t border-white/10">
            <p className="caption text-slate-300 mb-3">
              Enter security code <strong className="modal-code">{securityCode}</strong> to confirm:
            </p>
            <input
              type="text"
              maxLength={4}
              placeholder="Enter 4-digit code"
              value={typedCode}
              onChange={(e) => setTypedCode(e.target.value)}
              className="input input-code"
              autoFocus
            />
          </div>
        </div>

        <div className="modal-footer">

          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
          >
            <span className="btn-text">CANCEL</span>
          </button>
          <button
            type="button"
            disabled={!isCodeCorrect}
            className="btn btn-danger"
            onClick={() => {
              onConfirm(player);
              onClose();
            }}
          >
            <span className="btn-text">DELETE</span>
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default RemovePlayerModal;
